import React, {useEffect} from 'react';
import {parseCookies} from 'nookies';
import {MoonLoader} from 'react-spinners';
import {DeliveryService, usePreviewDeliveryQuery} from '@graphql/generated/graphql';
import {DELIVER_TO_ADDRESS, DELIVER_TO_LATITUDE, DELIVER_TO_LONGITUDE} from '@lib/helpers/helper';

interface IPreviewDeliveryProps {
  outletId?: string;
  storeId?: string;
  setDeliveryService: (service: DeliveryService) => void;
  setDeliveryData: (fee: number, metadata: string) => void;
}

const PreviewDelivery = ({outletId, storeId, setDeliveryService, setDeliveryData}: IPreviewDeliveryProps) => {
  const parsedCookies = parseCookies();
  const address = parsedCookies[DELIVER_TO_ADDRESS];
  const lat = +parsedCookies[DELIVER_TO_LATITUDE];
  const lng = +parsedCookies[DELIVER_TO_LONGITUDE];

  const {data, loading} = usePreviewDeliveryQuery({
    variables: {outletId, storeId, address, lat, lng},
    fetchPolicy: 'no-cache',
    skip: !address || !lat || !lng,
  });

  useEffect(() => {
    if (data?.previewDelivery) {
      const {serviceType, deliveryPrice, deliveryMetadata} = data.previewDelivery;
      setDeliveryService(serviceType);
      setDeliveryData(deliveryPrice, deliveryMetadata);
    }
  }, [data?.previewDelivery]);

  if (loading) {
    return (
      <div className="flex">
        <MoonLoader size={14} />
      </div>
    );
  }

  if (!data?.previewDelivery) {
    return (
      <div className="flex -ml-0.5 items-center gap-1">
        {WARNING_SVG}
        <p className="text-red-600 text-sm font-semibold">DELIVERY UNAVAILABLE</p>
      </div>
    );
  }

  return null;
};

export default PreviewDelivery;

const WARNING_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-red-600">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
  </svg>
);
